import { ScanDeviceListItem } from "./ScanDeviceListItem"
import { useEffect, useContext } from "react";
import { ModalContext } from "../../contexts/ModalContext";
import EnableBluetoothModal from "../Modals/EnableBluetooth/EnableBluetoothModal";
import centralStateTypes from "../../consts/centralStateTypes";

const ScanDeviceList = ({ devices, onDeviceSelected, onDeviceConnected, onDeviceUnselected, centralStateStatus }) => {

    const { openModal } = useContext(ModalContext);

    const openEnableBluetoothModal = () => {
        openModal(<EnableBluetoothModal/>);
    }

    useEffect(() => {
        if (centralStateStatus === centralStateTypes.POWERED_OFF) {
            openEnableBluetoothModal();
        }
    }, [centralStateStatus]);

    return (
        <div className='flex flex-col'>
            <div className="flex justify-start bg-blue-500 h-24 p-4 items-center">
                <h1 className="text-[32px] text-white">SAFARI BLE</h1>
                {/* <h3 className="text-lg text-white">Available devices:</h3> */}
            </div>
            <div className="flex flex-col gap-4 p-4">
                {devices?.map((device, index) => {
                    return (
                        <ScanDeviceListItem
                            key={`${device}-${index}`}
                            device={device}
                            onSelected={onDeviceSelected}
                            onConnected={onDeviceConnected}
                            onDeviceUnselected={onDeviceUnselected}
                        />
                    )
                })
                }
                {
                    devices?.length === 0 &&
                    <div className="mt-32 flex flex-col items-center justify-center">
                        <h1 className="text-2xl">No devices found</h1>
                        <p className="text-lg">Please make sure that the devices are turned on and nearby.</p>
                    </div>
                }
            </div>
        </div>
    )
}

export default ScanDeviceList;